import { centsToYuan } from '@/utils/amount'
import { formatTimestamp } from '@/utils/time'
import { WITHDRAW_STATUS_OPTIONS } from '@/const'
import { mapPayinStatusText, mapPayoutStatusText } from './payinHistoryFormat'

/** 存款历史导出列（表头由前端生成） */
export const PAYIN_EXPORT_COLUMNS = [
  { key: 'order_id', label: '订单号' },
  { key: 'third_order_id', label: '第三方订单ID' },
  { key: 'amount', label: '订单金额', format: 'money' },
  { key: 'currency', label: '货币类型' },
  { key: 'total_fee', label: '总手续费', format: 'money' },
  { key: 'uid', label: '玩家ID' },
  { key: 'created_at', label: '创建时间', format: 'time' },
  { key: 'status', label: '订单状态', format: 'payinStatus' },
]

/** 提款历史导出列 — TODO: 待后端/产品提供字段后补齐 
 * 
 * amount
: 
{
  "order_id": "OUT2056384611746844672",
  "third_order_id": "PAYOUT-2056385111733047296",
  "amount": 2500,
  "currency": "BRL",
  "total_fee": 50,
  "uid": 200330,
  "created_at": 1779115271877,
  "status": 8
}
*/
export const PAYOUT_EXPORT_COLUMNS = [
  { key: 'order_id', label: '订单号' },
  { key: 'third_order_id', label: '第三方订单ID' },
  { key: 'amount', label: '订单金额', format: 'money' },
  { key: 'currency', label: '货币类型' },
  { key: 'total_fee', label: '总手续费', format: 'money' },
  { key: 'uid', label: '玩家ID' },
  { key: 'created_at', label: '创建时间', format: 'time' },
  { key: 'status', label: '订单状态', format: 'payoutStatus' },
]

export function parseExportList(response) {
  const data = response?.data
  if (Array.isArray(data)) return data
  return data?.items || []
}

export function buildExportSheet(columns, list, formatCell) {
  const header = columns.map(c => c.label)
  const data = (list || []).map(row => columns.map(col => formatCell(col.key, row[col.key], row, col)))
  return { header, data }
}

function cellOrEmpty(value) {
  return value == null || value === '' ? '' : value
}

export function createPayinExportFormatCell() {
  return (key, value) => {
    switch (key) {
      case 'amount':
      case 'total_fee':
        return centsToYuan(value)
      case 'created_at':
        return formatTimestamp(value)
      case 'status':
        return mapPayinStatusText(value)
      default:
        return cellOrEmpty(value)
    }
  }
}

function resolveWithdrawStatusLabel(status) {
  let mapped = status
  if ([1, 2, 3, 4].includes(status)) {
    mapped = 4
  }
  return WITHDRAW_STATUS_OPTIONS.find(opt => opt.value === mapped)?.label || ''
}

export function createPayoutExportFormatCell() {
  return (key, value) => {
    switch (key) {
      case 'amount':
      case 'total_fee':
        return centsToYuan(value)
      case 'created_at':
      case 'updated_at':
        return formatTimestamp(value)
      case 'status':
        return resolveWithdrawStatusLabel(value)
      default:
        return cellOrEmpty(value)
    }
  }
}

export function isPayoutExportReady() {
  return PAYOUT_EXPORT_COLUMNS.length >= 0
}
